<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'clips' }">
          Clips</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="display-1 font-weight-bold my-5 text-capitalize">
        Add Clip
      </div>
      <v-form @submit.prevent="submit" ref="form">
        <div class="row">
          <div class="col-md-5">
            <label class="text-field-label">Title</label>
            <v-text-field
              flat
              solo
              required
              counter
              class="mt-2"
              :rules="rules.title"
              maxlength="255"
              v-model="form.title"
              :error-messages="form.$getError('title')"
            ></v-text-field>

            <label class="text-field-label">Video</label>
            <v-select
              flat
              solo
              required
              class="mt-2"
              :items="videos"
              item-text="name"
              item-value="id"
              v-model="form.video_id"
              :error-messages="form.$getError('video_id')"
              label="Select a video"
            ></v-select>

            <label class="text-field-label">Photo</label>
            <v-file-input
              :rules="rules.photo"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Pick a photo"
              :prepend-icon="icons.camera"
              v-model="form.photo"
              :error-messages="form.$getError('photo')"
            ></v-file-input>

            <div class="mt-4">
              <v-btn
                type="submit"
                color="primary"
                :loading="form.$busy"
                :disabled="disabledClip"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-form>
      <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
        {{ snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn text @click="snackbar.show = false" v-bind="attrs">OK</v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import { mdiChevronLeft, mdiCamera } from '@mdi/js'

export default {
  name: 'ClipCreate',
  data() {
    return {
      disabledClip: false,
      form: new Form({
        title: '',
        video_id: '',
        photo: null,
      }),
      icons: {
        arrowLeft: mdiChevronLeft,
        camera: mdiCamera,
      },
      rules: {
        title: [(v) => (v && v.length <= 255) || 'Max 255 characters'],
        photo: [(v) => !!v || 'Photo is required'],
      },
      snackbar: {
        show: false,
        message: null,
        color: '',
      },
    }
  },

  computed: {
    ...mapState('video', ['list']),
    videos() {
      return this.list.map((video) => ({
        id: video.id,
        name: video.name, // Assuming the video object has a `title` property
      }))
    },
  },

  methods: {
    ...mapActions('video', ['getVideos']),
    ...mapActions('clip', ['storeClip']),

    async fetchVideos() {
      try {
        await this.getVideos({ page: 1, sort: 'created_at' }) // Example params
      } catch (error) {
        this.showSnackbar('Failed to fetch videos', 'error')
      }
    },

    async submit() {
      this.form.$busy = true
      this.form.$clearErrors()

      const formData = new FormData()

      Object.entries(this.form.$data()).forEach(([key, value]) => {
        formData.append(key, value)
      })

      try {
        await this.storeClip(formData)
        this.snackbar.message = 'Clip successfully created!'
        this.snackbar.color = 'success'
        this.snackbar.show = true
        this.form.$reset()
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.form.$setErrors(error.response.data.errors)
        } else {
          this.showSnackbar('Failed to create clip', 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  },

  created() {
    this.fetchVideos()
  },
}
</script>
